import React, { useContext, useEffect, useState } from 'react';
import AOS from 'aos';
import { store } from '../../../App';
import { Carousel } from 'react-bootstrap';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Footer from '../../Footer';
import axios from 'axios';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import NextSteps from '../../NextSteps';
import '../../../css/AboutHome.css';
import { apiUrl } from '../../Constants';
import BannerCaptionOverlay from '../../BannerCaptionOverlay';


const getProductTitle = (item, isArabic) => {
  if (!item) return '';
  if (isArabic) {
    return item.menu_name_ar || item.name_ar || item.title_ar || item.menu_name_en || '';
  }
  return item.menu_name_en || item.name_en || item.title_en || item.title || '';
};

const getCategoryFallbackImage = (item, index = 0) => {
  const slug = (item?.slug || item?.menu_name_en || '').toLowerCase();
  if (slug.includes('medium') || slug.includes('heavy') || slug.includes('mhdt')) return '/Images/products_strip/mhdt.jpg';
  if (slug.includes('light') || slug.includes('ldt')) return '/Images/products_strip/ldt.png';
  if (slug.includes('mini-truck') || slug.includes('mini truck')) return '/Images/products_strip/mini_truck.jpg';
  if (slug.includes('pickup')) return '/Images/products_strip/pickup.jpg';
  if (slug.includes('van')) return '/Images/products_strip/van.jpg';
  if (slug.includes('bus')) return '/Images/products_strip/bus.jpg';
  const defaults = [
    '/Images/products_strip/mhdt.jpg',
    '/Images/products_strip/ldt.png',
    '/Images/products_strip/mini_truck.jpg',
    '/Images/products_strip/pickup.jpg',
    '/Images/products_strip/van.jpg',
    '/Images/products_strip/bus.jpg'
  ];
  return defaults[index % defaults.length];
};

const getProductImageUrl = (item, index = 0) => {
  if (!item) return getCategoryFallbackImage(null, index);
  const img = item.image || item.photo || item.banner;
  if (!img) {
    return item.fallbackImage || getCategoryFallbackImage(item, index);
  }
  const trimmed = String(img).trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('/') || trimmed.startsWith('data:')) {
    return trimmed;
  }
  const localStripFiles = ['mhdt.jpg', 'ldt.png', 'mini_truck.jpg', 'pickup.jpg', 'van.jpg', 'bus.jpg', 'ev.jpg'];
  if (localStripFiles.includes(trimmed.toLowerCase())) {
    return `/Images/products_strip/${trimmed}`;
  }
  return `https://dev10.sbagh.com/public/images/menus/large/${trimmed}`;
};

const getProductLink = (item) => {
  const target = item?.link || item?.slug || '';
  if (!target) return '/vehicles';
  if (target.startsWith('http://') || target.startsWith('https://')) return target;
  if (target.startsWith('/vehicles/')) return target;
  if (target.startsWith('vehicles/')) return `/${target}`;
  if (target.startsWith('/')) return target;
  return `/vehicles/${target}`;
};

const safeParse = (htmlString, fallback = null) => {
  if (typeof htmlString === 'string' && htmlString.trim().length > 0) {
    try {
      return parse(htmlString);
    } catch (e) {
      console.error("HTML parse error:", e);
      return fallback;
    }
  }
  return fallback;
};

const DEFAULT_HOME_BANNERS = [
  { id: 'b1', image: '/Images/Banners/MicrosoftTeams-image (9).png', image_alt: 'Foton Commercial Vehicles' },
  { id: 'b2', image: '/Images/Banners/MicrosoftTeams-image (10).png', image_alt: 'Foton Trucks' },
  { id: 'b3', image: '/Images/Banners/MicrosoftTeams-image (7).png', image_alt: 'Foton Vans' },
  { id: 'b4', image: '/Images/Banners/four.jpg', image_alt: 'Foton Oman' }
];

const isLocalEnv = () =>
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const getPublicAssetBase = () => {
  if (apiUrl && /^https?:\/\//i.test(apiUrl)) {
    try {
      return `${new URL(apiUrl).origin}/public`;
    } catch (e) {
      // fall through
    }
  }
  return 'https://dev10.sbagh.com/public';
};

/** Normalize CMS home banner list (supports nested or flat home_banners) */
const resolveHomeBanners = (homeData) => {
  const nested = homeData?.home_banners?.home_banners;
  const direct = homeData?.home_banners;
  const list = Array.isArray(nested)
    ? nested
    : (Array.isArray(direct) ? direct : []);

  return list
    .filter((b) => b && b.image && (b.status === undefined || Number(b.status) === 1))
    .sort((a, b) => (a.sort_order ?? 99) - (b.sort_order ?? 99));
};

const getBannerImageUrl = (img, cacheKey) => {
  if (!img) return '/Images/Banners/four.jpg';
  const trimmed = String(img).trim();
  if (!trimmed) return '/Images/Banners/four.jpg';

  let url;
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('/')) {
    url = trimmed;
  } else {
    // Encode each path segment so filenames with spaces/parentheses resolve
    const encoded = trimmed
      .split('/')
      .map((part) => encodeURIComponent(part))
      .join('/');
    url = `${getPublicAssetBase()}/images/gallery/large/${encoded}`;
  }

  // Bust browser/CDN cache when CMS replaces an image under the same filename
  if (cacheKey !== undefined && cacheKey !== null && cacheKey !== '') {
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}v=${encodeURIComponent(String(cacheKey))}`;
  }
  return url;
};

const extractImageFromHtml = (html) => {
  if (typeof html !== 'string') return null;
  const match = html.match(/<img[^>]+src=["']([^"']+)["']/i);
  return match ? match[1] : null;
};

const cleanDescriptionHtml = (html) => {
  if (typeof html !== 'string') return '';
  return html.replace(/<img[^>]*>/gi, '');
};

const getAboutImageUrl = (item, aboutSection) => {
  const directImage =
    item?.icon_file ||
    item?.image ||
    item?.photo ||
    item?.banner ||
    item?.image_file ||
    item?.file ||
    item?.media ||
    item?.section_image ||
    aboutSection?.icon_file ||
    aboutSection?.image ||
    aboutSection?.photo ||
    aboutSection?.banner ||
    aboutSection?.image_file ||
    aboutSection?.about_image;

  if (directImage) {
    const trimmed = String(directImage).trim();
    if (
      trimmed.startsWith('http://') ||
      trimmed.startsWith('https://') ||
      trimmed.startsWith('/') ||
      trimmed.startsWith('data:')
    ) {
      return trimmed;
    }
    if (trimmed.includes('/')) {
      return `https://dev10.sbagh.com/${trimmed.replace(/^\/+/, '')}`;
    }
    // Admin uploads for GeneralSection icon_file go to public/images/general-section/large/
    return `https://dev10.sbagh.com/public/images/general-section/large/${trimmed}`;
  }

  // Check if an image is embedded inside description HTML (from WYSIWYG editor)
  const fromDesc =
    extractImageFromHtml(item?.description_en) ||
    extractImageFromHtml(item?.description_ar);
  if (fromDesc) {
    return fromDesc;
  }

  // Dynamic General Section fallback from Foton Commercial vehicle gallery
  return 'https://dev10.sbagh.com/public/images/general-section/large/1698900658-Medium-Heavy-Duty-Truck-2-hi.jpg';
};

const DEFAULT_FOTON_PRODUCTS_SECTION_TITLE = {
  category_title_en: "FOTON PRODUCTS",
  category_title_ar: "منتجات فوتون",
  highlight_en: "<p>With all series Commercial Vehicle business, Foton Motor is one of the leading Commercial Vehicle manufactures in the world.</p>",
  highlight_ar: "<p>مع جميع سلاسل أعمال المركبات التجارية، تعد شركة فوتون موتور واحدة من الشركات الرائدة في تصنيع المركبات التجارية في العالم.</p>"
};

const extractDynamicProductsFromMenus = (menus) => {
  if (!Array.isArray(menus) || menus.length === 0) return [];

  // 1. Locate the main products/models category menu
  const modelsMenu = menus.find(
    (m) =>
      m.id === 3 ||
      m.slug === 'models' ||
      (m.menu_name_en && m.menu_name_en.toLowerCase().includes('product'))
  );
  const children = modelsMenu?.children || [];

  // 2. Include any standalone commercial vehicle product categories from the API (e.g. Mini Bus)
  const standalone = menus.filter(
    (m) =>
      (m.menu_type === 1 ||
        m.slug === 'mini-bus' ||
        ['mini-truck', 'van', 'mini-bus', 'pickup', 'light-duty-trucks', 'medium-duty-truck'].includes(m.slug)) &&
      !children.some((c) => c.id === m.id || c.slug === m.slug)
  );

  const combined = [...children, ...standalone];
  if (combined.length === 0) return [];

  // 3. Sort strictly by API sort order
  combined.sort((a, b) => {
    const sortA = parseInt(a.sort, 10) || 999;
    const sortB = parseInt(b.sort, 10) || 999;
    return sortA - sortB;
  });

  return combined;
};

const DEFAULT_ABOUT_US = [
  {
    category_title_en: "Gulf Great Sands – Official Distributor of Foton in Oman",
    category_title_ar: "رمال الخليج الكبرى – الموزع الرسمي لـ فوتون في عمان",
    description_en: "<p>Gulf Great Sands LLC was established in 2016 in Oman and has built a strong reputation for supporting the growth and development of industries across the country. Founded with a passion for excellence and a forward-looking vision, the company continues to evolve through innovation, reliability, and customer-focused solutions.</p><p>Gulf Great Sands LLC specializes in automotive passenger vehicles and commercial vehicle solutions, delivering dependable mobility for diverse business needs. As the official distributor of BAIC and Foton in Oman, we provide a comprehensive range of vehicles backed by global expertise, advanced technology, and trusted aftersales support—ensuring lasting value for our customers.</p>",
    description_ar: "<p>تأسست شركة رمال الخليج الكبرى ش.م.م في عام 2016 في سلطنة عمان، وبنت سمعة قوية في دعم نمو وتطور الصناعات في جميع أنحاء البلاد. انطلاقاً من شغفنا بالتميز ورؤيتنا المستقبلية، تواصل الشركة التطور من خلال الابتكار والموثوقية والحلول التي تركز على العملاء.</p><p>تتخصص شركة رمال الخليج الكبرى ش.م.م في حلول مركبات الركاب والمركبات التجارية، مما يوفر تنقلاً موثوقاً لمختلف احتياجات الأعمال. وبصفتنا الموزع الرسمي لـ BAIC وفوتون في عُمان، فإننا نقدم مجموعة شاملة من المركبات المدعومة بالخبرة العالمية والتكنولوجيا المتقدمة ودعم ما بعد البيع الموثوق به - مما يضمن قيمة دائمة لعملائنا.</p>",
    image: "1698900658-Medium-Heavy-Duty-Truck-2-hi.jpg"
  }
];

function Home() {
  const [lang] = useContext(store);
  const [home, setHome] = useState();
  const [dynamicProducts, setDynamicProducts] = useState([]);

  useEffect(() => {
    const homeEndpoint = apiUrl ? `${apiUrl}getHomePageDataBySlug/home` : 'https://dev10.sbagh.com/api/getHomePageDataBySlug/home';
    const localHomeEndpoint = 'http://localhost/foton-oman-backend/api/getHomePageDataBySlug/home';
    const menusEndpoint = apiUrl ? `${apiUrl}getMenus` : 'https://dev10.sbagh.com/api/getMenus';

    const applyHomeData = (remoteData) => {
      if (!remoteData) return false;
      setHome(remoteData);
      setTimeout(() => {
        AOS.refresh();
      }, 100);
      return true;
    };

    const hasUsableHomePayload = (payload) => {
      if (!payload?.data) return false;
      // API sometimes returns HTTP 200 with { success: false, message: 204 }
      if (payload.success === false) return false;
      return true;
    };

    // 1. Fetch Home Page data (banners, section title, highlight description, seo)
    axios
      .get(homeEndpoint)
      .then((response) => {
        if (hasUsableHomePayload(response?.data) && applyHomeData(response.data.data)) {
          return;
        }
        console.warn('Primary home API returned no usable data, trying local fallback…');
        if (!isLocalEnv()) return;
        return axios.get(localHomeEndpoint).then((localRes) => {
          if (hasUsableHomePayload(localRes?.data)) {
            applyHomeData(localRes.data.data);
          }
        });
      })
      .catch((err) => {
        console.warn('Could not load home page data from primary endpoint:', err?.message);
        if (!isLocalEnv()) return;
        axios.get(localHomeEndpoint)
          .then((localRes) => {
            if (hasUsableHomePayload(localRes?.data)) {
              applyHomeData(localRes.data.data);
            }
          })
          .catch(() => {});
      });

    // 2. Fetch dynamic products directly from getMenus API
    axios
      .get(menusEndpoint)
      .then((res) => {
        const menus = res?.data?.data?.menus;
        const products = extractDynamicProductsFromMenus(menus);
        if (products.length > 0) {
          setDynamicProducts(products);
        }
      })
      .catch((err) => {
        console.warn('Could not load menus from primary endpoint:', err?.message);
        if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
          axios.get('http://localhost/foton-oman-backend/api/getMenus')
            .then((localRes) => {
              const menus = localRes?.data?.data?.menus;
              const products = extractDynamicProductsFromMenus(menus);
              if (products.length > 0) {
                setDynamicProducts(products);
              }
            })
            .catch(() => {});
        }
      });
  }, []);

  // 100% Dynamic products list fetched from API
  const displayProducts = (dynamicProducts && dynamicProducts.length > 0)
    ? dynamicProducts
    : (home?.foton_products?.products && home.foton_products.products.length > 0)
    ? home.foton_products.products
    : [];

  const cmsBanners = resolveHomeBanners(home);
  const banners = cmsBanners.length > 0 ? cmsBanners : DEFAULT_HOME_BANNERS;

  const sectionTitle = (home?.foton_products?.section_title && home.foton_products.section_title.length > 0)
    ? home.foton_products.section_title[0]
    : DEFAULT_FOTON_PRODUCTS_SECTION_TITLE;

  return (
    <>
      <Helmet>
        <title>{home?.seo?.meta_title || "Foton Oman | Commercial Vehicles"}</title>
        <meta name="description" content={home?.seo?.meta_description || "Foton Oman Commercial Vehicles"}></meta>
        <meta name="keywords" content={home?.seo?.meta_keywords || "Foton, Trucks, Vans, Oman"}></meta>
        {home?.seo?.canonical && <link rel="canonical" href={home.seo.canonical} />}
      </Helmet>

      <Carousel
        className="home-hero-carousel"
        prevIcon={
          <span className="carousel-highlight-btn" aria-hidden="true">
            <FaChevronLeft size={22} />
          </span>
        }
        nextIcon={
          <span className="carousel-highlight-btn" aria-hidden="true">
            <FaChevronRight size={22} />
          </span>
        }
      >
        {banners.map((img, idx) => {
          const cacheKey = img.updated_at || img.updated_on || img.id || img.sort_order || idx;
          const src = getBannerImageUrl(img.image, cacheKey);
          const alt = img.image_alt || img.title_en || img.title_ar || 'Foton Banner';
          return (
            <Carousel.Item key={img.id || idx} className="home-hero-carousel-item">
              <div className="home-hero-slide-wrapper">
                <img
                  src={src}
                  width="100%"
                  className="home-hero-banner-img"
                  alt={alt}
                  onError={(e) => {
                    e.target.onerror = null;
                    // Retry without cache-bust, then local fallback
                    const plain = getBannerImageUrl(img.image);
                    if (e.target.src !== plain) {
                      e.target.src = plain;
                      return;
                    }
                    e.target.src = DEFAULT_HOME_BANNERS[idx % DEFAULT_HOME_BANNERS.length].image;
                  }}
                />
                <BannerCaptionOverlay
                  item={img}
                  isRtl={Boolean(lang)}
                />
              </div>
            </Carousel.Item>
          );
        })}
      </Carousel>

      {/* FOTON PRODUCTS SECTION - 100% Dynamic API driven with fotonmotor.com design */}
      {displayProducts && displayProducts.length > 0 && (
        <section className="foton-products-section-wrap" data-aos="fade-up">
          <div className="foton-products-heading-area text-center">
            <h2 className="foton-products-title">
              {lang
                ? (sectionTitle.category_title_ar || "منتجات فوتون")
                : (sectionTitle.category_title_en || "FOTON PRODUCTS")}
            </h2>
            <div className="foton-products-subtitle text-muted">
              {lang
                ? (safeParse(sectionTitle.highlight_ar) || sectionTitle.highlight_ar || "مع جميع سلاسل أعمال المركبات التجارية، تعد شركة فوتون موتور واحدة من الشركات الرائدة في تصنيع المركبات التجارية في العالم.")
                : (safeParse(sectionTitle.highlight_en) || sectionTitle.highlight_en || "With all series Commercial Vehicle business, Foton Motor is one of the leading Commercial Vehicle manufactures in the world.")}
            </div>
          </div>

          <div className="foton-split-strip-container">
            {displayProducts.map((item, index) => {
              const title = getProductTitle(item, lang);
              const targetLink = getProductLink(item);
              const imageUrl = getProductImageUrl(item, index);

              return (
                <Link
                  to={targetLink}
                  key={item.id || item.slug || index}
                  className="foton-split-panel"
                  title={title}
                >
                  <div className="foton-split-bg">
                    <img
                      src={imageUrl}
                      alt={title}
                      className="foton-split-img"
                      loading="lazy"
                      onError={(e) => {
                        e.target.onerror = null;
                        const fallback = getCategoryFallbackImage(item, index);
                        if (e.target.src !== fallback) {
                          e.target.src = fallback;
                        }
                      }}
                    />
                  </div>

                  {/* Subtle dark mask on hover (matching fotonmotor.com .split-mask) */}
                  <div className="split-mask"></div>

                  <div
                    className="foton-split-top"
                    style={{
                      textAlign: lang ? 'right' : 'left',
                      right: lang ? '32px' : 'auto',
                      left: lang ? 'auto' : '32px'
                    }}
                  >
                    <h3 className="foton-split-name">
                      {title}
                    </h3>
                  </div>
                </Link>
              );
            })}
          </div>
        </section>
      )}


      {/* ABOUT GULF GREAT SANDS SECTION (BAIC OMAN OVERVIEW STYLE) */}
      <section className={`about-ggs-section ${lang ? 'rtl' : 'ltr'}`}>
        <div className="about-ggs-container">
          {(home?.about_us?.section_title && home.about_us.section_title.length > 0
            ? home.about_us.section_title
            : DEFAULT_ABOUT_US
          ).map((item, index) => {
            const rawTitle = lang
              ? (item.category_title_ar || "رمال الخليج الكبرى – الموزع الرسمي لـ فوتون في عمان")
              : (item.category_title_en || "Gulf Great Sands – Official Distributor of Foton in Oman");

            let mainTitle = lang ? "رمال الخليج الكبرى" : "Gulf Great Sands";
            let subtitle = lang ? "– الموزع الرسمي لـ فوتون في عمان" : "– Official Distributor of Foton in Oman";

            if (rawTitle.includes('–') || rawTitle.includes('-')) {
              const delimiter = rawTitle.includes('–') ? '–' : '-';
              const parts = rawTitle.split(delimiter);
              mainTitle = parts[0].trim();
              subtitle = `– ${parts.slice(1).join(delimiter).trim()}`;
            } else if (rawTitle.toLowerCase().includes('about') || rawTitle.includes('حول') || rawTitle.includes('عن')) {
              mainTitle = lang ? "رمال الخليج الكبرى" : "Gulf Great Sands";
              subtitle = lang ? "– الموزع الرسمي لـ فوتون في عمان" : "– Official Distributor of Foton in Oman";
            } else {
              mainTitle = rawTitle;
              subtitle = "";
            }

            const imageSrc = getAboutImageUrl(item, home?.about_us);

            return (
              <div key={item.id || index}>
                <div className="about-ggs-header" data-aos="fade-up">
                  <h2 className="about-ggs-title">
                    {mainTitle}
                    {subtitle && <span className="about-ggs-subtitle">{subtitle}</span>}
                  </h2>
                </div>

                <div className="about-ggs-content">
                  <div className="about-ggs-left" data-aos="fade-up">
                    <div className="about-ggs-text">
                      {lang
                        ? safeParse(cleanDescriptionHtml(item.description_ar))
                        : safeParse(cleanDescriptionHtml(item.description_en))}
                    </div>
                    <div>
                      <Link to="/about-us" className="about-ggs-readmore">
                        {lang ? 'اقرأ المزيد' : 'Read More'}
                        <span className="about-ggs-arrow">{lang ? '←' : '→'}</span>
                      </Link>
                    </div>
                  </div>

                  <div className="about-ggs-right" data-aos="fade-up" data-aos-delay="150">
                    <div className="about-ggs-image-card">
                      <div className="about-ggs-image-accent"></div>
                      <img
                        src={imageSrc}
                        alt={mainTitle || "Gulf Great Sands Showroom"}
                        className="about-ggs-img"
                        onError={(e) => {
                          const current = e.target.src;
                          if (current.includes('/images/general-section/large/')) {
                            e.target.src = current.replace('/images/general-section/large/', '/images/general-section/thumb/');
                          } else if (current.includes('/images/about/large/')) {
                            e.target.src = current.replace('/images/about/large/', '/images/about/');
                          } else if (!current.includes('Medium-Heavy-Duty-Truck-2')) {
                            e.target.onerror = null;
                            e.target.src = '/Images/logo/Medium-Heavy-Duty-Truck-2.jpg';
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <NextSteps />
      <Footer />

    </>

  )
}

export default Home
